const GroupQueryKeys = {
  global: ["groups"] as const,

  /**
   * Group Lists
   */
  fromTags: (tagId: string) =>
    [...GroupQueryKeys.global, "fromTags", tagId] as const,
  fromCategories: (categoryId: string) =>
    [...GroupQueryKeys.global, "fromCategories", categoryId] as const,
  mutes: () => [...GroupQueryKeys.global, "mutes"] as const,
  pending: () => [...GroupQueryKeys.global, "pending"] as const,
  popular: () => [...GroupQueryKeys.global, "popular"] as const,
  search: () => [...GroupQueryKeys.global, "search"] as const,
  searchBy: (q: string, limit: number) =>
    [...GroupQueryKeys.search(), q, limit] as const,
  searchByDiscover: (q: string) =>
    [...GroupQueryKeys.global, "discover", "search", q] as const,
  suggested: () => [...GroupQueryKeys.global, "suggested"] as const,

  /**
   * Group Details
   */

  /** @deprecated Internal: do not use */
  details: () => [...GroupQueryKeys.global, "details"] as const,
  /** Used to fetching a single Account */
  group: (groupId: string) => [...GroupQueryKeys.details(), groupId] as const,
  groupFromSlug: (slug: string) =>
    [...GroupQueryKeys.details(), "slug", slug] as const,
};

export { GroupQueryKeys };
